export const T = {
  en_GB: {
    portfolioSource: "Portfolio",
    newPortfolio: "New portfolio",
    existingPortfolio: "Existing portfolio",
  },
  nb_NO: {
    portfolioSource: "Portefølje",
    newPortfolio: "Ny portefølje",
    existingPortfolio: "Eksisterende portefølje",
  },
} as const;
